<template>
    <h1>Empty page</h1>
</template>

<script lang="ts">
export default {
    layout: 'default',

    async created() {
        // await this.$i18n.setLocale(this.$config.locale)
    },
}
</script>
